import React from "react";
import { Col, Row } from "react-bootstrap";
import {
    DiJavascript1,
    DiHtml5,
    DiCss3,
  } from "react-icons/di";
import {
  SiTypescript,
  SiNextdotjs,
} from "react-icons/si";

function Languagestack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <DiHtml5 />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiCss3 />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTypescript />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiNextdotjs />
      </Col>
    </Row>
  );
}

export default Languagestack;
